import store from '~/store'

export default async (to, from, next) => {
  if (!store.getters['questions/questions'].length > 0) {
    store.dispatch('questions/fetchAllQuestions')
    store.dispatch('accessories/fetchAccessories')
  }

  next()
}



// WEBPACK FOOTER //
// ./resources/js/middleware/load-carousel.js